module.exports = __webpack_public_path__ + "media/component-library/signup-form/images/facebook-icon-4328c9bb2eb6bb18a6ef2cca56131602.svg";